import { CopilotStudioIconUrl } from "@p0security/shared/integrations/constants";
import type { AIPlatform } from "@p0security/shared/types/ai-inventory";

export type PlatformMeta = {
  iconUrl?: string;
  supportsEnvironments: boolean;
};

export const PLATFORM_META: Record<AIPlatform, PlatformMeta> = {
  "copilot-studio": {
    iconUrl: CopilotStudioIconUrl,
    supportsEnvironments: true,
  },
  bedrock: { supportsEnvironments: true },
  "local-agents": { supportsEnvironments: false },
};
